import type { VfConfig } from '#types/config/components/vf'

export default {
  iconSize: 'md',
  sort: {
    brandClasses: {
      container: 'h-10 b rounded-xs',
      icon: 'absolute inset-y-0 right-0 my-a mr-3',
      text: 'text-sm pl-3 pr-10'
    }
  }
} satisfies VfConfig['select']
